// helpers
import storage from 'shared/helpers/storage';

// constants
const COACH_MARK_KEY = 'URGENCY_NUDGE_COACHMARK';

enum COACH_MARK_CONFIG {
  TO_SHOW = 0,
  TO_NOT_SHOW = 1,
}

export const setCoachMarkShownToUser = () => {
  storage.setItem(COACH_MARK_KEY, COACH_MARK_CONFIG.TO_NOT_SHOW);
};

export const shouldShowCoachMark = () => {
  const hasShownCoachMark = storage.getItem(COACH_MARK_KEY) || 0;
  return hasShownCoachMark === COACH_MARK_CONFIG.TO_SHOW;
};
